import getDatapointStatus from 'owa-analytics/lib/utils/getDatapointStatus';
import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { PerformanceDatapoint } from 'owa-analytics/lib/datapoints/PerformanceDatapoint';
import { setFontScale } from 'mini-app-module-store/lib/mutator/setFontScale';

const FONT_SCALE_KEY = 'fontScale';

export const initializeFontScale = () => {
    if (isMiniHostAppFeatureEnabled('fontScale') && isMiniFeatureEnabled('lite-font-scale')) {
        const datapoint = new PerformanceDatapoint('FontScale', { isCore: true });

        try {
            const fontScale = getMiniHostAppDetail()[FONT_SCALE_KEY] ?? 1;
            setFontScale(fontScale);

            const scale = getComputedStyle(document.body).getPropertyValue('--fontScale');
            if (scale) {
                document.body.style.setProperty('--fontScale', fontScale.toString());
            }

            datapoint.end();
        } catch (error) {
            datapoint.endWithError(getDatapointStatus(error.message, error).status, error);
        }
    }
};
